import { createAction } from '../../services';
export const SET_BLOG_DATA = 'appData/SET';
export const setAppData = createAction(SET_BLOG_DATA);
export const FETCH_BLOG_DATA_REQUEST = 'appData/FETCH_REQUEST';
export const FETCH_BLOG_DATA_SUCCESS = 'appData/FETCH_SUCCESS';
export const FETCH_BLOG_DATA_FAILURE = 'appData/FETCH_FAILURE';
export const fetchAppDataRequest = () => ({ type: FETCH_BLOG_DATA_REQUEST });
export const fetchAppDataSuccess = (payload) => ({
    type: FETCH_BLOG_DATA_SUCCESS,
    payload,
});
export const fetchAppDataFailure = () => ({ type: FETCH_BLOG_DATA_FAILURE });
//# sourceMappingURL=app-data-actions.js.map